module.exports = __webpack_public_path__ + "media/images/logo_large-386e59fe59929cff036dfa90d755cd52.png";